// extracted by mini-css-extract-plugin
export const hasShadow = "DefaultTemplate-module--hasShadow--Qt083";